import dayjs from "dayjs";
import {
  checkOrderByDayMonthYear,
  updateOrderClient,
  addOrderClient,
} from "../utility/EndPointGoogleFirebase";

export async function handleSaveOrders(
  inputValues,
  selectedItem,
  selectedDate,
  fetchOrders,
  resetInputValues,
  setNotification
) {
  const {
    pane,
    varie,
    acconto,
    note,
    default: defaultValue,
  } = inputValues;

  const quantityKgPane = isNaN(parseFloat(pane))    ? 0 : parseFloat(pane);
  const amountVarie    = isNaN(parseFloat(varie))   ? 0 : parseFloat(varie);
  const deposit        = isNaN(parseFloat(acconto)) ? 0 : parseFloat(acconto);
  const Default        = parseFloat(defaultValue) || 3; // default pane sempre 3

  // Controlla se c'è almeno un campo compilato (0 è un valore valido)
  const hasValues =
    pane    !== "" && pane    !== undefined && pane    !== null ||
    varie   !== "" && varie   !== undefined && varie   !== null ||
    acconto !== "" && acconto !== undefined && acconto !== null;

  if (hasValues) {
    const totalPrice = quantityKgPane * Default + amountVarie - deposit;

    const day   = dayjs(selectedDate).format("D");
    const month = dayjs(selectedDate).format("M");
    const year  = dayjs(selectedDate).format("YYYY");

    let order = {
      cliente: selectedItem,
      pane:    quantityKgPane,
      varie:   amountVarie,
      acconto: deposit,
      note:    note || "",
      giorno:  day,
      mese:    month,
      anno:    year,
      totale:  totalPrice,
    };

    try {
      const resultOrder = await checkOrderByDayMonthYear(
        selectedItem,
        day,
        month,
        year
      );

      if (resultOrder && !resultOrder.empty) {
        resultOrder.forEach((doc) => {
          const updatedOrder = {
            ...order,
            pane:    quantityKgPane,
            varie:   amountVarie,
            acconto: deposit,
            totale:  totalPrice,
            note:    note || "",
          };

          updateOrderClient(updatedOrder, doc.id)
            .then(() => {
              fetchOrders();
              setNotification?.({ type: "success", message: "Ordine aggiornato con successo!" });
            })
            .catch((error) => {
              console.error("Errore nell'aggiornamento dell'ordine:", error);
              setNotification?.({ type: "error", message: "Errore nell'aggiornamento dell'ordine!" });
            });
        });
      } else {
        addOrderClient(order)
          .then((docRef) => {
            fetchOrders();
            setNotification?.({ type: "success", message: "Ordine salvato con successo!" });
          })
          .catch((error) => {
            console.error("Errore durante il salvataggio dell'ordine:", error);
            setNotification?.({ type: "error", message: "Errore durante il salvataggio dell'ordine!" });
          });
      }
    } catch (error) {
      console.error("Errore durante il controllo dell'ordine:", error);
      setNotification?.({ type: "error", message: "Errore durante il controllo dell'ordine!" });
    }
  } else {
    setNotification?.({ type: "error", message: "Inserisci almeno un valore per salvare l'ordine!" });
  }
}